export default {
  metadata: {
    version: '1.0.0',
    id: 'content-card-1.0.0',
    name: 'JDSContentCard',
    description:
      'Content cards are blocks of content that contain various combinations of components in different structures.',
    usage:
      'Content cards are used to organise content in meaningful blocks within a page.'
  },
  hierarchy: {
    'root-container': [
      {
        'header-container': ['header-slot']
      },
      {
        'image-content-container': ['jds_image', 'jds_content_block']
      },
      {
        'children-container': ['children-slot']
      },
      'footer-jds-text'
    ]
  },
  base: {
    'root-container': {
      overflow: 'hidden',
      width: '{c_0}',
      'border-radius': '{c_1}',
      'flex-direction': '{c_2}',
      'justify-content': '{c_3}',
      'align-items': '{c_4}',
      'background-color': '{c_5}',
      'padding-bottom': '{c_29}',
      gap: '{base}',
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '#00000014'
      },
      behavior: {
        hover: {
          'box-shadow': {
            x: 0,
            y: 4,
            blur: 16,
            spread: 0,
            color: '#0000000E'
          }
        }
      }
    },
    'header-container': {
      hidden: false,
      'justify-content': '{c_6}',
      'align-items': '{c_7}',
      width: '{c_8}',
      'padding-left': '{c_9}',
      'padding-right': '{c_10}'
    },
    'children-container': {
      hidden: false,
      'justify-content': '{c_12}',
      'align-items': '{c_13}',
      width: '{c_14}',
      'padding-left': '{c_15}'
    },
    'image-content-container': {
      'flex-direction': '{c_18}',
      width: '{c_19}',
      'justify-content': '{c_20}',
      'align-items': '{c_21}',
      gap: '{base}'
    },
    jds_image: {
      aspectRatio: 'horizontal_16_9',
      roundedCorner: true,
      imageFocus: 'center'
    },
    jds_content_block: {
      size: 'xtra-small',
      'padding-left': '{c_24}',
      'padding-right': '{c_25}'
    },
    'footer-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-left': '{c_27}',
      'padding-right': '{c_28}'
    }
  },
  variant: {
    imageRatio: {
      square: {
        jds_image: {
          aspectRatio: 'square'
        }
      },
      landscape: {
        jds_image: {
          aspectRatio: 'horizontal_4_3'
        }
      },
      portrait: {
        jds_image: {
          aspectRatio: 'vertical_4_5'
        }
      }
    },
    shadow: {
      false: {
        'root-container': {
          'box-shadow': {
            x: 0,
            y: 0,
            blur: 0,
            spread: 0,
            color: '#00000000'
          }
        }
      }
    },
    _hasHeaderSlot: {
      false: {
        'header-container': {
          hidden: true
        },
        'image-content-container': {
          'padding-top': 0
        }
      }
    },
    _hasChildrenSlot: {
      false: {
        'children-container': {
          hidden: true
        }
      }
    },
    _hasContentBlockAndImageProps: {
      false: {
        'image-content-container': {
          hidden: true
        }
      }
    },
    _hasContentBlockProps: {
      false: {
        jds_content_block: {
          hidden: true
        }
      }
    },
    _hasImageProps: {
      false: {
        'image-content-container': {
          'padding-top': 0
        },
        jds_image: {
          hidden: true
        },
        jds_content_block: {
          'padding-top': 0
        }
      }
    },
    condensed: {
      true: {
        jds_content_block: {
          ctaWrap: 'vertical'
        }
      }
    },
    orientation: {
      horizontal: {
        jds_content_block: {
          'padding-left': 0
        }
      }
    }
  },
  combination: [
    {
      false: {
        'xtra-xtra-small': {
          jds_content_block: {
            size: 'xtra-xtra-small'
          }
        },
        small: {
          jds_content_block: {
            size: 'small'
          }
        },
        medium: {
          jds_content_block: {
            size: 'medium'
          }
        },
        large: {
          jds_content_block: {
            size: 'large'
          }
        },
        'xtra-large': {
          jds_content_block: {
            size: 'xtra-large'
          }
        }
      }
    },
    {
      true: {
        horizontal: {
          'image-content-container': {
            'padding-left': '{c_30}',
            'padding-top': '{c_31}',
            'flex-direction': '{c_32}'
          },
          jds_image: {
            flex: '0.2',
            aspectRatio: 'square'
          },
          jds_content_block: {
            flex: '0.8',
            size: 'xtra-xtra-small'
          }
        },
        vertical: {
          'root-container': {
            width: '{c_33}'
          },
          jds_image: {
            aspectRatio: 'square'
          },
          jds_content_block: {
            size: 'xtra-xtra-small'
          }
        }
      },
      false: {
        horizontal: {
          'root-container': {
            width: '{c_34}'
          },
          'image-content-container': {
            'padding-left': '{c_35}',
            'padding-top': '{c_36}',
            'flex-direction': '{c_37}'
          },
          jds_image: {
            flex: '0.3'
          },
          jds_content_block: {
            flex: '0.7'
          }
        }
      }
    },
    {
      true: {
        vertical: {
          mobile: {
            'root-container': {
              width: '{c_38}'
            }
          }
        }
      }
    },
    {
      horizontal: {
        false: {
          jds_content_block: {
            flex: 1,
            'padding-left': 0
          }
        }
      }
    }
  ],
  combination_config: [
    ['condensed', 'size'],
    ['condensed', 'orientation'],
    ['condensed', 'orientation', '_platform'],
    ['orientation', '_hasImageProps']
  ],
  api: {
    children: {
      'header-slot': {
        name: 'header',
        accepts: ['jds_list_block'],
        max: 1
      },
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1
      }
    },
    config: {
      size: {
        values: [
          'xtra-small',
          'xtra-xtra-small',
          'small',
          'medium',
          'large',
          'xtra-large'
        ]
      },
      orientation: {
        values: ['vertical', 'horizontal'],
        doc_description:
          'Horizontal orientation puts image and content side by side.'
      },
      imageRatio: {
        values: ['wide', 'square', 'landscape', 'portrait']
      },
      shadow: {
        values: [true, false],
        doc_description: 'Toggle drop shadow'
      },
      condensed: {
        values: [false, true]
      },
      _hasHeaderSlot: {
        values: [true, false]
      },
      _hasChildrenSlot: {
        values: [true, false]
      },
      _hasContentBlockAndImageProps: {
        values: [true, false]
      },
      _hasContentBlockProps: {
        values: [true, false]
      },
      _hasImageProps: {
        values: [true, false]
      },
      _platform: {
        values: ['desktop', 'mobile']
      }
    },
    data: {
      'root-container': {
        fullCardCTA: {
          type: 'string',
          name: 'fullCardCTA',
          doc_description:
            'When present, the entire card is clickable. If any other CTAs are sent, they will not be clickable.'
        }
      },
      jds_content_block: {
        title: {
          type: 'string',
          name: 'title'
        },
        description: {
          type: 'string',
          name: 'description'
        },
        primaryCTA: {
          type: 'string',
          name: 'primaryCTA'
        },
        secondaryCTA: {
          type: 'string',
          name: 'secondaryCTA'
        },
        caption: {
          type: 'slot',
          name: 'caption',
          accepts: ['jds_badge', 'jds_text', 'jds_tag'],
          function: true
        },
        ctaWrap: {
          type: 'JDSContentBlock.ctaWrap',
          name: 'ctaWrap'
        },
        isTertiary: {
          type: 'boolean',
          name: 'isTertiary'
        }
      },
      jds_image: {
        src: {
          type: 'image',
          name: 'image'
        },
        borderRadius: {
          type: 'size',
          default: 24,
          name: 'borderRadius'
        },
        imageFocus: {
          type: 'JDSImage.imageFocus',
          name: 'imageFocus'
        }
      },
      'footer-jds-text': {
        value: {
          type: 'string',
          name: 'footer'
        }
      }
    },
    events: {
      'root-container': {
        onClick: 'onClick'
      },
      jds_content_block: {
        onPrimaryClick: 'onPrimaryClick',
        onSecondaryClick: 'onSecondaryClick'
      }
    },
    a11y: {
      jds_image: {
        properties: {
          ariaLabel: 'imageAriaLabel',
          ariaDescribedby: {
            name: 'imageAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_content_block: {
        properties: {
          primaryCtaAriaLabel: 'primaryCtaAriaLabel',
          primaryCtaAriaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          },
          secondaryCtaAriaLabel: 'secondaryCtaAriaLabel',
          secondaryCtaAriaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
